import { createContext, useContext } from 'react';

import type { DictateOnboardingContextValue } from '../dictate-onboarding.types';

export const DictateOnboardingContext =
  createContext<DictateOnboardingContextValue | null>(null);

export function useDictateOnboardingContext(): DictateOnboardingContextValue {
  const ctx = useContext(DictateOnboardingContext);
  if (!ctx) {
    throw new Error(
      'useDictateOnboardingContext must be used inside DictateOnboardingProvider'
    );
  }
  return ctx;
}

/** Returns null outside `DictateOnboardingProvider` (e.g. returning sign-in flow). */
export function useOptionalDictateOnboardingContext(): DictateOnboardingContextValue | null {
  return useContext(DictateOnboardingContext);
}
